import { render } from "./AboutmeSimp.vue?vue&type=template&id=b3bbbe3a&scoped=true"
import script from "./AboutmeSimp.vue?vue&type=script&lang=js"
export * from "./AboutmeSimp.vue?vue&type=script&lang=js"

import "./AboutmeSimp.vue?vue&type=style&index=0&id=b3bbbe3a&lang=scss&scoped=true"

import exportComponent from "/Users/jaxz/Desktop/wangyan-campaign/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b3bbbe3a"]])

export default __exports__